<template>
  <div
    class="aj-partnerLogo"
    :class="classObject"
  >
    <div
      v-if="useFallback || forceFallback"
      class="aj-partnerLogo__fallback"
    >
      <span
        class="aj-partnerLogo__fallbackLogo"
        :class="`-colorGroup${fallbackFirstLetter}`"
      >
        {{ fallbackFirstLetter }}
      </span>
      <slot
        v-if="showFallbackName"
        name="fallbackName"
      >
        <aj-text
          class="aj-partnerLogo__fallbackName"
          body-medium
        >
          {{ name }}
        </aj-text>
      </slot>
    </div>
    <template v-else>
      <img
        v-lazy="src"
        class="aj-partnerLogo__image"
        :name="name"
        :alt="name"
        :data-slug="slug"
        :data-srcset="src2x"
        :style="imageStyleObject"
      >
    </template>
  </div>
</template>

<script>
import AjText from '../AjText/AjText.vue';

export default {
  name: 'AjPartnerLogo',
  components: { AjText },
  props: {
    grayscale: {
      type: Boolean,
      default: false,
    },
    name: {
      validator: prop => typeof prop === 'string' || prop === undefined,
      required: true,
    },
    slug: {
      validator: prop => typeof prop === 'string' || prop === undefined,
      required: true,
    },
    circle: {
      type: Boolean,
      default: false,
    },
    forceFallback: {
      type: Boolean,
      default: false,
    },
    showFallbackName: {
      type: Boolean,
      default: false,
    },
    imageWidth: {
      type: String,
      default: '',
    },
    imageHeight: {
      type: String,
      default: '',
    },
  },

  data () {
    return {
      useFallback: false,
    };
  },

  computed: {
    classObject () {
      return {
        '-circle': this.circle,
      };
    },

    src () {
      return `${this.baseSrc}1x.png`;
    },

    src2x () {
      return `${this.baseSrc}2x.png 2x`;
    },

    baseSrc () {
      let url = '//res.cloudinary.com/hhgz8qnrm/image/upload/f_auto';
      if (this.grayscale) {
        url += '/e_grayscale';
      }
      return `${url}/partners/logos/${this.slug}`;
    },

    imageStyleObject () {
      return {
        height: this.imageHeight || (this.imageWidth ? 'auto' : ''),
        width: this.imageWidth || (this.imageHeight ? 'auto' : ''),
      };
    },

    fallbackFirstLetter () {
      return this.name.charAt(0);
    },
  },

  mounted () {
    this.$nextTick(() => {
      this.$Lazyload.$on('error', listener => {
        if (!this.useFallback && listener.el.dataset.slug === this.slug) {
          this.fallback();
        }
      });
    });
  },

  methods: {
    fallback () {
      this.useFallback = true;
      this.$emit('partner-logo-missing', this.slug);
    },
  },
};
</script>

<style lang="scss" src="./AjPartnerLogo.scss" />
